import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Anonieme cross-origin scriptfouten (van externe platform-scripts) niet als app-fout tonen.
window.addEventListener(
  "error",
  (e) => {
    if (e.message === "Script error." && !e.filename) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
